<template>
    <filter-modal-shell name="advanced-failed-filters-modal" :title="$t('frontend_groovesell_modal_advanced_filters')"
        subtitle-empty="Narrow failed rebills by funnel and affiliate." :active-count="activeCount"
        :can-apply="!defaultFilters" :apply-label="$t('frontend_analytics_apply_filters')"
        @apply="emitStartSearch" @reset="resetFilters">

        <section class="afm__section">
            <div class="afm__section-head">
                <h3 class="afm__section-title">{{ $t('frontend_analytics_funnels') }}</h3>
                <p class="afm__section-hint">Tick a funnel for everything in it, or drill into products and price points.</p>
            </div>
            <funnel-picker :options="funnelsDropdown" :value="filteredFunnels" @input="filteredFunnelsChanged" />
        </section>

        <section class="afm__section">
            <div class="afm__section-head">
                <h3 class="afm__section-title">{{ $t('frontend_analytics_affiliates') }}</h3>
            </div>
            <affiliate-scope :value="filteredAffiliates" :options="affiliatesForFilter"
                :label="$t('frontend_analytics_affiliates')" @input="affiliatesChanged" />
        </section>
    </filter-modal-shell>
</template>
<script>
import FilterModalShell from '../parts/FilterModalShell';
import FunnelPicker from '../parts/FunnelPicker';
import AffiliateScope from '../parts/AffiliateScope';

export default {
    components: {
        FilterModalShell,
        FunnelPicker,
        AffiliateScope,
    },
    props: {
        filteredFunnels: {
            type: Array,
            default: () => [],
        },
        funnelsDropdown: {
            type: Array,
            default: () => [],
        },
        filteredAffiliates: {
            type: Array,
            default: () => [],
        },
        affiliatesForFilter: {
            default: () => [],
        },
    },
    computed: {
        defaultFilters() {
            return this.filteredFunnels?.length == 0 && this.isAll(this.filteredAffiliates);
        },
        activeCount() {
            let n = 0;
            if (this.filteredFunnels?.length > 0) n += 1;
            if (!this.isAll(this.filteredAffiliates)) n += 1;
            return n;
        },
    },
    methods: {
        isAll(list) {
            return list?.length == 1 && list[0].id == 0 && list[0].name === 'All';
        },
        affiliatesChanged(value) {
            this.$emit('filter-changed', {
                key: 'filteredAffiliates',
                value,
                startSearch: false,
            })
        },
        filteredFunnelsChanged(value) {
            this.$emit('filter-changed', {
                key: 'filteredFunnels',
                value,
            })
        },
        resetFilters() {
            this.$emit('filter-changed', {
                key: 'clear',
                values: [
                    { key: 'filteredFunnels', value: [] },
                    { key: 'filteredAffiliates', value: [{ id: 0, name: 'All' }] },
                ],
            });
        },
        emitStartSearch() {
            // The old multiselect never allowed an empty affiliate list; keep that guarantee.
            if (this.filteredAffiliates.length === 0) {
                this.$emit('filter-changed', {
                    key: 'filteredAffiliates',
                    value: [{ id: 0, name: 'All' }],
                });
            }
            this.$emit('apply-filters');
            this.$root.$emit('modal-close', 'advanced-failed-filters-modal');
        },
    }
}
</script>
